// src/mocks/data/business.js
// Plan helpers (vertical-agnostic) + re-exports of the active vertical's
// business profile fixtures.

import { active } from "./verticals";

export { getBusinessTypeFromUrl } from "./vertical";

const VALID_PLANS = ["solo", "team", "manager_start", "manager_plus", "manager_pro", "enterprise"];
const DEFAULT_PLAN = "manager_pro";

export function getPlanFromUrl() {
  if (typeof window === "undefined") return DEFAULT_PLAN;
  // index.jsx salveaza ?plan= in sessionStorage inainte de orice navigare.
  const stored = sessionStorage.getItem("demo_plan") || "";
  const fromUrl = new URLSearchParams(window.location.search).get("plan") || "";
  const p = stored || fromUrl;
  return VALID_PLANS.includes(p) ? p : DEFAULT_PLAN;
}

export const PLAN_FEATURES = {
  solo:          { appointments: true,  clients: false, staff: false, services: true,  stats: false, inventory: false, sms: false, sms_campaigns: false, chat: false },
  team:          { appointments: true,  clients: true,  staff: true,  services: true,  stats: false, inventory: false, sms: false, sms_campaigns: false, chat: false },
  manager_start: { appointments: true,  clients: true,  staff: true,  services: true,  stats: true,  inventory: false, sms: false, sms_campaigns: false, chat: false },
  manager_plus:  { appointments: true,  clients: true,  staff: true,  services: true,  stats: true,  inventory: false, sms: false, sms_campaigns: false, chat: false },
  manager_pro:   { appointments: true,  clients: true,  staff: true,  services: true,  stats: true,  inventory: true,  sms: true,  sms_campaigns: true,  chat: true },
  enterprise:    { appointments: true,  clients: true,  staff: true,  services: true,  stats: true,  inventory: true,  sms: true,  sms_campaigns: true,  chat: true },
};

export const BUSINESS = active.BUSINESS;
export const LOCATION = active.LOCATION;
export const WORKING_HOURS = active.WORKING_HOURS;
export const BUSINESS_SETTINGS = active.BUSINESS_SETTINGS;
